<template>
  <div class="text-textColor">
    <transition name="fade">
      <div
        v-if="showCreateStrategicGoal"
        class="bg-black fixed bg-opacity-70 inset-0 z-50 h-screen w-full"
      >
        <form
          @submit.prevent="create"
          class="fixed center-h-v bg-white rounded-md shadow-2xl sm:w-2/5 w-full md:h-auto h-screen overflow-auto"
        >
          <transition name="fade">
            <div
              v-if="loading"
              class="inset-0 absolute bg-black rounded-md bg-opacity-10 w-full"
            >
              <loader class="center-h-v" />
            </div>
          </transition>

          <div
            class="flex justify-between items-center bg-white sticky top-0 border-b-1.5 p-3"
          >
            <p class="text-base">Add Strategic Goal</p>
            <img
              class="h-6 object-contain cursor-pointer hover:shadow-lg bg-primary rounded-md"
              src="@/assets/icons/cross-white.png"
              @click="close()"
            />
          </div>
          <transition name="fade">
            <div
              v-if="inputError"
              class="p-1 text-center text-sm w-full bg-yellow-200"
            >
              {{ inputError }}
            </div>
          </transition>
          <transition name="fade">
            <div
              v-if="edit_success"
              class="p-1 text-center text-sm w-full bg-green-200"
            >
              {{ edit_success }}
            </div>
          </transition>
          <div class="grid grid-cols-1 p-4 gap-5">
            <div class="text-sm">
              <label class="block pb-1">Review Period</label>
              <select
                v-model="info.ReviewPeriodId"
                class="p-2 bg-gray-200 rounded-full w-full"
              >
                <option
                  v-for="period in ReviewPeriodIds"
                  :key="period.Id"
                  :value="period.Id"
                >
                  {{ period.Name }}
                </option>
              </select>
            </div>
            <div class="text-sm">
              <label class="block">Target</label>
              <select v-model="selectedTarget" class="p-2 bg-gray-200 rounded-full w-full">
                <option value="organization">Entire Organization</option>
                <option value="branch">Branch</option>
                <option value="department">Department</option>
              </select>
            </div>
              <div v-if="selectedTarget !== 'organization'">
                <div class="text-sm">
                  <label class="block pb-1 capitalize">Company</label>
                  <select
                      v-model="info.LocationId"
                      required
                      class="p-2 bg-gray-200 rounded-full w-full"
                      @change="setBranches"
                  >
                    <option v-for="location in saved_locations" :key="location.Name" :value="location.Id">
                      {{ location.Name }}
                    </option>
                  </select>
                </div>

                <div class="text-sm mt-5">
                  <label class="block pb-1 capitalize">Branch</label>
                  <select
                      v-model="info.BranchId"
                      class="p-2 bg-gray-200 rounded-full w-full"
                      @change="setDepartments"
                  >
                    <option v-for="branch in branchesToSelect" :key="branch.Id" :value="branch.Id">
                      {{ branch.Name }}
                    </option>
                  </select>
                </div>
              </div>

              <div v-if="selectedTarget === 'department'" class="text-sm">
                <label class="block pb-1 capitalize">Department</label>
                <select
                    v-model="info.DepartmentId"
                    required
                    class="p-2 bg-gray-200 rounded-full w-full"
                    @click="setDepartments"
                >
                  <option v-for="department in departmentsToSelect" :key="department.DepartmentId" :value="department.DepartmentId">
                    {{ department.Name }}
                  </option>
                </select>
              </div>
            <!-- Name -->
            <div class="text-sm">
              <label class="block pb-1">Strategic Goal Name</label>
              <input
                v-model="info.Name"
                required
                type="text"
                class="p-2 bg-gray-200 rounded-full w-full"
              />
            </div>

            <div class="text-sm">
              <label class="block pb-1">Description</label>
              <textarea
                v-model="info.Description"
                required
                rows="5"
                class="p-2 bg-gray-200 rounded-md w-full"
              />
            </div>
          </div>

          <div class="flex justify-end p-5">
            <button
              class="bg-primary rounded-full px-10 text-sm text-white py-2"
            >
              Create
            </button>
          </div>
        </form>
      </div>
    </transition>
  </div>
</template>

<script>
import Loader from "@/components/loader/loader.vue";
import axios from "axios";

import { mapGetters } from "vuex";
export default {
  name: "CreateReviewPeriodId",
  props: ["showCreateStrategicGoal", "reload"],
  components: { Loader },
  data() {
    return {
      info: {
        ReviewPeriodId: null,
        Name: null,
        Description: null,
        LocationId: '',
        BranchId: '',
        DepartmentId: '',
      },
      ReviewPeriodIds: [],
      loading: false,
      isFocused: false,
      rawInput: "",
      inputError: "",
      selectedTarget: "organization",
    };
  },
  computed: {
    ...mapGetters(["getOrganization", "getToken"]),

    displayValue() {
      // Display raw input when focused, formatted percentage when blurred
      return this.isFocused ? this.rawInput : `${this.info.Weight}%`;
    },
  },
  watch: {
    inputError() {
      setTimeout(() => {
        this.inputError = "";
      }, 3000);
    },
    showCreateStrategicGoal(newState) {
      if (newState) {
        this.getPerformancePeriodSetups();
      }
    },
  },
  created() {
    this.getPerformancePeriods();
    this.getSavedData()
  },
  methods: {
    getSavedData() {
      this.loading = true;
      let endpoints = [
        `${this.getOrganization}/setup/location/${this.$ApiVersion}/request`,
        `${this.getOrganization}/setup/branch/${this.$ApiVersion}/request`,
        `${this.getOrganization}/setup/department/${this.$ApiVersion}/request`,
        `${this.getOrganization}/setup/jobtitle/${this.$ApiVersion}/request`,
      ];
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };

      Promise.all(endpoints.map((endpoint) => axios.get(endpoint, options)))
          .then(
              axios.spread((...response) => {
                this.loading = false;
                this.saved_locations = response[0].data.Data;
                this.saved_branches = response[1].data.Data;
                this.saved_departments = response[2].data.Data;
                this.saved_jobTitles = response[3].data.Data;
              })
          )
          .catch(() => {
            this.loading = false;
          });
    },
    setBranches() {
      this.branchesToSelect = this.saved_branches.filter(
          (branch) => branch.LocationId === this.info.LocationId
      );
      this.setDepartments();
    },

    setDepartments() {
      if (this.info.BranchId) {
        this.departmentsToSelect = this.saved_departments.filter(
            (department) => department.BranchId === this.info.BranchId
        );
      } else {
        this.departmentsToSelect = this.saved_departments.filter(
            (department) =>
                department.LocationName.trim().toLowerCase() ===
                this.info.LocationId.trim().toLowerCase() &&
                department.BranchId == ''
        );

      }
    },
    close() {
      this.$emit("close");
      this.info = {
        Name: null,
        Description: null,
        Weight: "",
      };
      this.reload()
    },
    create() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "application/json",
        },
      };
      try {
        axios
          .post(
            `${this.getOrganization}/performance/strategic/goal/${this.$ApiVersion}/create`,
            JSON.stringify(this.info),
            options
          )
          .then((response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.$notify.success({
                title: "Success",
                message: response.data.StatusMessage,
              });

              this.info = {
                ...this.info,
                Name: null,
                Description: null,
              };
            } else {
              this.loading = false;
              this.$notify.error({
                title: "Failure",
                message: response.data.StatusMessage,
              });
            }
          })
          .catch((error) => {
            this.loading = false;
            this.$notify.error({
              title: "Failure",
              message: error?.message,
            });
          });
      } catch (error) {
        this.loading = false;
        this.$notify.error({
          title: "Failure",
          message: error?.message,
        });
      }
    },

    // performance/period/v1/request
    getPerformancePeriods() {
      this.loading = true;
      let url = `${this.getOrganization}/performance/period/${this.$ApiVersion}/request`;

      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios.get(url, options).then(
        (response) => {
          this.loading = false;
          if (response.data.StatusCode == 200) {
            //console.log(response.data.Data);
            this.ReviewPeriodIds = response.data.Data;
          } else {
            this.$notify.error({
              title: "Failure",
              message: response.StatusMessage,
            });
          }
        },
        (error) => {
          this.loading = false;
          this.$notify.error({ title: "Failure", message: error.message });
        }
      );
    },

    onInput(event) {
      let value = event.target.value;

      // Remove non-numeric characters except for a single decimal point
      value = value.replace(/[^0-9.]/g, "");

      // Ensure only one decimal point is allowed
      const decimalIndex = value.indexOf(".");
      if (decimalIndex !== -1) {
        // Keep only the first decimal point and remove others
        value =
          value.slice(0, decimalIndex + 1) +
          value.slice(decimalIndex + 1).replace(/\./g, "");
      }

      // Convert to number
      let numericValue = parseFloat(value);

      if (numericValue > 100) {
        this.inputError = "Weight cannot exceed 100%";
        setTimeout(() => {
          this.rawInput = "";
          this.info.Weight = "";
        }, 2000);
      }

      // Ensure it's a multiple of 5
      // if (numericValue % 5 !== 0) {
      //   numericValue = Math.round(numericValue / 5) * 5;
      // }

      // Update raw input and model
      this.rawInput = isNaN(numericValue) ? "" : numericValue.toString();
      this.info.Weight = isNaN(numericValue) ? 0 : numericValue;
    },
    onFocus() {
      // On focus, show the raw input value
      this.isFocused = true;
      this.rawInput = this.info.Weight.toString();
    },
    onBlur() {
      // On blur, show the formatted value
      this.isFocused = false;
    },

    getPerformancePeriodSetups() {
      this.loading = true;
      let url = `${this.getOrganization}/performance/period/${this.$ApiVersion}/request`;

      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios.get(url, options).then(
        (response) => {
          this.loading = false;
          if (response.data.StatusCode == 200) {
            //console.log(response.data.Data);
            this.tableData = response.data.Data;
          } else {
            this.$notify.error({
              title: "Failure",
              message: response.StatusMessage,
            });
          }
        },
        (error) => {
          this.loading = false;
          this.$notify.error({ title: "Failure", message: error.message });
        }
      );
    },
  },
};
</script>

<style scoped>
.center-h-v {
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
</style>
